import React from "react"
import { useShallow } from "zustand/react/shallow"

// components
import { Tooltip } from "antd"

// stores
import useAuthoringStore from "../../../../hooks/stores/useAuthoringStore"
import useAuthoringViewStore from "../../../../hooks/stores/useAuthoringViewStore"

// apis
import { useUnlockAuthoringForm } from "api/hooks/studies/useAuthoringApi"
import { useUserPermissions } from "api/hooks"

export default function ReadOnlyActions({ authoringId }) {
  const { data: permissions } = useUserPermissions()
  const unlockAuthoringForm = useUnlockAuthoringForm(authoringId)

  const { lockedFullname, setIsUserLocked, setShowSaveLock } = useAuthoringStore(
    useShallow((state) => ({
      lockedFullname: state.lockedFullname,
      setIsUserLocked: state.setIsUserLocked,
      setShowSaveLock: state.setShowSaveLock,
    }))
  )

  const { setReadOnly } = useAuthoringViewStore(
    useShallow((state) => ({
      setReadOnly: state.setReadOnly,
    }))
  )

  let message = "editing"
  if (lockedFullname === "ETL Load") message = "in progress"

  const handleUnlocking = () => {
    unlockAuthoringForm(authoringId, {
      onSuccess: () => {
        setIsUserLocked(false)
        setShowSaveLock(false)
      },
    })
  }

  const onHandleUnlock = () => {
    handleUnlocking()
    setReadOnly(false)
  }

  return (
    <div className="read-only-actions-container">
      <div className="authoring-hover-text">
        {!permissions?.["study.unlock"] && (
          <i
            style={{ marginRight: 4 }}
            className="fas fa-lock-alt"
          />
        )}
        {lockedFullname} is {message}
      </div>

      {permissions?.["study.unlock"] && (
        <div
          onClick={onHandleUnlock}
          style={{ marginRight: 16 }}
        >
          <Tooltip
            title={`Unlock form`}
            placement={"left"}
          >
            <i
              className="fas fa-lock-alt"
              style={{
                cursor: "pointer",
                color: "#D7542C",
              }}
            />
          </Tooltip>
        </div>
      )}
    </div>
  )
}
